// Implements: F-VER-004, F-VER-007, F-UIX-015
/**
 * The dictionary key of each kind of piece a version holds.
 *
 * A kind that is not here is not an error: the backend vocabulary is closed
 * but extensible, so the caller shows the raw kind under its own name.
 */

export type KindKey =
  | "version.artifact.htmlBody"
  | "version.artifact.css"
  | "version.artifact.js"
  | "version.artifact.diagram"
  | "version.artifact.diagramWalkthrough";

const KIND_KEYS: Readonly<Record<string, KindKey>> = {
  html_body: "version.artifact.htmlBody",
  css: "version.artifact.css",
  js: "version.artifact.js",
  diagram: "version.artifact.diagram",
  // Mockup v3 P6 (C6.3): the screen walkthrough, stored as its own piece.
  diagram_walkthrough: "version.artifact.diagramWalkthrough",
};

export function kindKey(kind: string): KindKey | undefined {
  return KIND_KEYS[kind];
}
